/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useId, useState } from 'react'
import Highcharts from 'highcharts'
import HC_data from 'highcharts/modules/data'
import { LineChart } from '../../../types/StatTypes'
import ChartSkeleton from '../../skeleton/ChartSkeleton'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../reducers/users'
import BaseChart from '../../charts/BaseChart'

interface IVisualizationsBasicLineChartProps {
  chartData: LineChart
  defaultColour?: boolean
  height?: string
  xAxisTitle?: string
  yAxisTitle?: string
}

const VisualizationsBasicLineChart = (props: IVisualizationsBasicLineChartProps) => {
  const { chartData, height, xAxisTitle, yAxisTitle, defaultColour } = props
  const [isLoading, setIsLoading] = useState(true)
  const { darkModeEnabled } = useSelector(selectUser)
  const textColor = darkModeEnabled ? '#FFFFFF' : '#1c2024'
  const chartId = useId()

  useEffect(() => {
    if (chartData) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 400)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  useEffect(() => {
    if (typeof HC_data === 'function') {
      HC_data(Highcharts)
    }
  }, [])

  const options: any = {
    chart: {
      height: height ? height : '500px',
      backgroundColor: 'transparent',
    },
    data: {
      chartData,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: chartData.categories,
      tickInterval: 1,
      gridLineWidth: 1,
      title: {
        text: xAxisTitle ? xAxisTitle : '',
        style: {
          color: textColor, // Apply color to x-axis title
        },
      },
      labels: {
        style: {
          color: textColor, // Apply color to x-axis labels
        },
      },
    },
    yAxis: {
      title: {
        text: yAxisTitle ? yAxisTitle : 'Threat Count',
        style: {
          color: textColor, // Apply color to x-axis title
        },
      },
      labels: {
        format: '{value:.,0f}',
        style: {
          color: textColor, // Apply color to x-axis title
        },
      },
    },
    tooltip: {
      shared: true,
      crosshairs: true,
    },
    plotOptions: {
      series: {
        cursor: 'pointer',
        className: 'popup-on-click',
        marker: {
          lineWidth: 1,
        },
      },
    },
    series: chartData.series,
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  }

  if (defaultColour === false) {
    options.colors = ['#38d9a9', '#339af0', '#7048e8']
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default VisualizationsBasicLineChart
